/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrforeground1Inputs */

const en_qrforeground1 = /** @type {(inputs: Qrforeground1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foreground`)
};

const de_qrforeground1 = /** @type {(inputs: Qrforeground1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vordergrund`)
};

/**
* | output |
* | --- |
* | "Foreground" |
*
* @param {Qrforeground1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrforeground1 = /** @type {((inputs?: Qrforeground1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrforeground1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrforeground1(inputs)
	return de_qrforeground1(inputs)
});
export { qrforeground1 as "qrForeground" }